import React, { Suspense } from "react";
import { useContainer } from "unstated-next";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import "./tailwind.scss";

import Navbar from "./components/UI/Navbar/Navbar";
import Footer from "./components/UI/Footer/Footer";
import LoadingSpinner from "./components/UI/Spinner/LoadingSpinner";
import ScrollToTop from "./components/UI/ScrollToTop";
import Tokens from "./store/tokens";
import AlertToast from "./components/UI/Alert/AlertToast";

const MovieList = React.lazy(() => import("./containers/MovieList"));
const MovieDetails = React.lazy(() => import("./containers/MovieDetails"));
const Favorites = React.lazy(() => import("./containers/Favorites"));
const Search = React.lazy(() => import("./containers/Search"));
const GetRequestToken = React.lazy(() => import("./containers/GetRequestToken"));
const GetSessionId = React.lazy(() => import("./containers/GetSessionId"));

const App: React.FC = () => {
  const { accountId } = useContainer(Tokens);

  let routes = (
    <Switch>
      <Route path="/movies" component={MovieList} exact />
      <Route path="/movie/:movieId" component={MovieDetails} exact />
      <Route path="/search" component={Search} exact />
      <Route path="/get-request-token" component={GetRequestToken} exact />
      <Route path="/get-session-id" component={GetSessionId} exact />
      <Redirect to="/movies" />
    </Switch>
  );

  if (accountId) {
    routes = (
      <Switch>
        <Route path="/movies" component={MovieList} exact />
        <Route path="/movie/:movieId" component={MovieDetails} exact />
        <Route path="/search" component={Search} exact />
        <Route path="/favorites" component={Favorites} exact />
        <Route path="/get-session-id" component={GetSessionId} exact />
        <Redirect to="/movies" />
      </Switch>
    );
  }

  return (
    <BrowserRouter>
      <AlertToast />
      <ScrollToTop />
      <Navbar />
      <Suspense
        fallback={
          <div className="suspense">
            <LoadingSpinner />
          </div>
        }
      >
        <div className="mainContainer">{routes}</div>
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
